import { render, staticRenderFns } from "./AuthModal.vue?vue&type=template&id=dbab87a2&"
import script from "./AuthModal.vue?vue&type=script&lang=js&"
export * from "./AuthModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports